<template>
  <div class="topfans-scene topfans-section">
    <h3 class="title font-30">推广场景</h3>
    <p class="subtitle">
      懂粉丝，更懂粉丝经济 让世界听到你的声音，同时利用微博强大的社交属性
      ，从粉丝资产积累到变现
    </p>
    <div class="body app-basic-layout-wrapper">
      <div class="card-wrapper app-flex-row-space-between">
        <div class="card">
          <div class="icon-image">
            <img src="@/assets/img/topfans/scene_1.png" alt="" />
          </div>
          <h3>更多曝光</h3>
          <p>提升内容热度，让更多的目标客户看到你的博文，提升曝光量</p>
        </div>
        <div class="card">
          <div class="icon-image">
            <img src="@/assets/img/topfans/scene_2.png" alt="" />
          </div>
          <h3>更多粉丝</h3>
          <p>
            推荐博文给感兴趣的目标用户，增加你的粉丝数量，实现账户冷启动和用户增长
          </p>
        </div>
        <div class="card">
          <div class="icon-image">
            <img src="@/assets/img/topfans/scene_3.png" alt="" />
          </div>
          <h3>更多互动</h3>
          <p>
            获得更多感兴趣用户的点赞、留言评论等互动，提升粉丝粘性和用户转化效果
          </p>
        </div>
      </div>
    </div>
    <div class="footer">
      <a
        href="https://weibo.com/u/3587960280"
        target="_blank"
        class="zixun-btn"
      >
        免费咨询，开始使用
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'topfans-scene'
}
</script>

<style lang="scss" scoped>
.topfans-scene {
  background-color: #f4f5f7;
  &.topfans-section {
    padding-top: 88px;
  }
  .subtitle {
    margin-bottom: 60px;
  }
  .card-wrapper {
    padding: 0 60px;
    box-sizing: border-box;
  }
  .card {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 100px;
    &:last-child {
      margin-right: 0;
    }
    .icon-image {
      width: 168px;
      height: 168px;
      overflow: hidden;
      img {
        max-width: 100%;
        max-height: 100%;
        float: left;
        object-fit: cover;
      }
    }
    h3 {
      font-size: 24px;
      margin: 16px 0;
    }
    p {
      text-align: center;
    }
  }
  .footer {
    text-align: center;
    margin-top: 48px;
    .zixun-btn {
      background-color: $danger-color;
      color: #ffffff;
      display: inline-block;
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      border-radius: 24px;
      padding: 0 32px;
    }
  }
}
</style>
